import styled from 'styled-components'
import { Field } from 'formik'

import { lighten } from 'polished'
import { checkIsWhite } from '~/assets/styles/helpers'
import { colors, fontSizes, sizes } from '~/assets/styles/variables'

const {
  blue, darkGray, disabledBlue, gray, white,
} = colors

const { fontSize16 } = fontSizes

const {
  size8, size15, size16, size100Percent,
} = sizes

interface FormInputInterface {
  textAlign: string
}

const FormInput = styled(Field)`
  background-color: ${white};
  border: 2px solid ${gray};
  border-radius: ${size8};
  color: ${({ theme: { palette } }) => (checkIsWhite(palette.primary.main) ? blue : palette.primary.main)};
  font-family: inherit;
  font-size: ${fontSize16};
  font-weight: 600;
  padding: ${size16};
  text-align: ${({ textAlign }: FormInputInterface) => textAlign};
  transition: border-color 0.25s;
  width: ${size100Percent};

  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &.select {
    padding: ${size15} ${size16};
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }

  ::placeholder {
    color: ${darkGray};
  }

  :disabled {
    background: ${gray};
    color: ${disabledBlue};
  }

  :focus {
    border-color: ${({ theme: { palette } }) => lighten(0.3, palette.primary.main)};
  }
`

export default FormInput
